var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgFlowRefundLv12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 749.999,
    height: 80,
    viewBox: "0 0 749.999 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2050",
    "data-name": "\\uADF8\\uB8F9 2050",
    transform: "translate(6050.999 -13647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2040",
    "data-name": "\\uADF8\\uB8F9 2040",
    transform: "translate(-9210.16 15242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_104",
    "data-name": "\\uD0C0\\uC6D0 104",
    transform: "translate(3829.16 -1595)",
    fill: "#00aab7",
    stroke: "#d5f0f2",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 36,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uCFE0\\uD3F0_\\uD3D0\\uAE30_\\uC644\\uB8CC_",
    "data-name": "\\uCFE0\\uD3F0 \\uD3D0\\uAE30 \\uC644\\uB8CC ",
    transform: "translate(3869.16 -1558)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -25.942,
    y: 0
  }, "\uCFE0\uD3F0 \uD3D0\uAE30"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.096,
    y: 16
  }, "\uC644\uB8CC"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2043",
    "data-name": "\\uADF8\\uB8F9 2043",
    transform: "translate(-8389.855 7502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 128,
    height: 52,
    rx: 4,
    transform: "translate(2646.766 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uCFE0\\uD3F0_\\uD3D0\\uAE30_\\uC9C4\\uD589_\\uC911",
    "data-name": "\\uCFE0\\uD3F0 \\uD3D0\\uAE30 \\uC9C4\\uD589 \\uC911",
    transform: "translate(2710.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -47.586,
    y: 0
  }, "\uCFE0\uD3F0 \uD3D0\uAE30 \uC9C4\uD589 \uC911"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2041",
    "data-name": "\\uADF8\\uB8F9 2041",
    transform: "translate(-8241.855 7502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-2",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 158,
    height: 52,
    rx: 4,
    transform: "translate(2664.765 6159)",
    fill: "#363636"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uCFE0\\uD3F0\\uD3D0\\uAE30_\\uD655\\uC815_\\uC81C\\uD734\\uC0AC_",
    "data-name": "\\uCFE0\\uD3F0\\uD3D0\\uAE30 \\uD655\\uC815 (\\uC81C\\uD734\\uC0AC)",
    transform: "translate(2743.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -62.692,
    y: 0
  }, "\uCFE0\uD3F0\uD3D0\uAE30 \uD655\uC815 (\uC81C\uD734\uC0AC)"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2048",
    "data-name": "\\uADF8\\uB8F9 2048",
    transform: "translate(-8582.999 7502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uC0AC\\uAC01\\uD615_797",
    "data-name": "\\uC0AC\\uAC01\\uD615 797",
    transform: "translate(2532 6159)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 52,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 79,
    height: 51,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\uCFE0\\uD3F0_\\uBC1C\\uD589",
    "data-name": "\\uCFE0\\uD3F0 \\uBC1C\\uD589",
    transform: "translate(2572 6189)",
    fill: "#222",
    fontSize: 13,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24.089,
    y: 0
  }, "\uCFE0\uD3F0 \uBC1C\uD589"))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2047",
    "data-name": "\\uADF8\\uB8F9 2047",
    transform: "translate(-9649.894 14727.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2045",
    "data-name": "\\uADF8\\uB8F9 2045",
    transform: "translate(-9459.895 14727.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-2",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-2",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-2",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2044",
    "data-name": "\\uADF8\\uB8F9 2044",
    transform: "translate(-9293.895 14727.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-3",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-3",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-3",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2042",
    "data-name": "\\uADF8\\uB8F9 2042",
    transform: "translate(-9097.896 14727.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_548-4",
    "data-name": "\\uADF8\\uB8F9 548",
    transform: "translate(3712.305 -1044.646) rotate(90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_89-4",
    "data-name": "\\uC120 89",
    y1: 32.09,
    transform: "translate(4.23 1.41)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB2E4\\uAC01\\uD615_19-4",
    "data-name": "\\uB2E4\\uAC01\\uD615 19",
    fill: "#707070"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.604809284210205 7.019761085510254 L 0.8549216985702515 7.019761085510254 L 4.229865550994873 1.019867897033691 L 7.604809284210205 7.019761085510254 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4.229865550994873 2.039734840393066 L 1.709847927093506 6.519761085510254 L 6.74988317489624 6.519761085510254 L 4.229865550994873 2.039734840393066 M 4.229865550994873 9.5367431640625e-07 L 8.459735870361328 7.519761085510254 L -4.76837158203125e-06 7.519761085510254 L 4.229865550994873 9.5367431640625e-07 Z",
    stroke: "none",
    fill: "#707070"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2046",
    "data-name": "\\uADF8\\uB8F9 2046",
    transform: "translate(-8567.854 7502)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_798-3",
    "data-name": "\\uC0AC\\uAC01\\uD615 798",
    width: 152,
    height: 52,
    rx: 4,
    transform: "translate(2634.765 6159)",
    fill: "#00aab7"
  }), /*#__PURE__*/React.createElement("text", {
    id: "\\uD3D0\\uAE30_\\uB9AC\\uC2A4\\uD2B8_\\uC790\\uB3D9_\\uC0DD\\uC131",
    "data-name": "\\uD3D0\\uAE30 \\uB9AC\\uC2A4\\uD2B8 \\uC790\\uB3D9 \\uC0DD\\uC131",
    transform: "translate(2710.765 6190)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "Pretendard-Regular, Pretendard"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -59.682,
    y: 0
  }, "\uD3D0\uAE30 \uB9AC\uC2A4\uD2B8 \uC790\uB3D9 \uC0DD\uC131"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFlowRefundLv12);
export default __webpack_public_path__ + "static/media/img_flow_refund_lv12.3337388ab5a55cb7eec315d82fd35591.svg";
export { ForwardRef as ReactComponent };